export const API_ENDPOINTS = {
  SYDNEY_METRO_DB: '/nsw_gtfs_positions/sydney-metro/db',
  SYDNEY_TRAINS_DB: '/nsw_gtfs_positions/sydney-trains/db',
} as const

export const REFRESH_INTERVALS = {
  VEHICLE_POSITIONS: 30000, // 30 seconds
  MAP_UPDATE: 30000, // 30 seconds
} as const

export const MAP_CONFIG = {
  SYDNEY_CENTER: [151.2093, -33.8688] as [number, number],
  DEFAULT_ZOOM: 10,
  MIN_ZOOM: 8,
  MAX_ZOOM: 18,
} as const
